import { TUserAccountForm } from './types';

export const initialUserAccountForm: TUserAccountForm = {
  firstName: '',
  lastName: '',
  email: '',
  serviceCenter: null,
  serviceCenters: [],
  dealerships: [],
  role: null,
};
